export default "__VITE_ASSET__C5c78jez__"